import { render, staticRenderFns } from "./step-select-signature-type.vue?vue&type=template&id=fb560d1a&scoped=true&"
import script from "./step-select-signature-type.vue?vue&type=script&lang=js&"
export * from "./step-select-signature-type.vue?vue&type=script&lang=js&"
import style0 from "./step-select-signature-type.vue?vue&type=style&index=0&id=fb560d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb560d1a",
  null
  
)

export default component.exports